import { AccountingRefundsComponent } from './refunds/accounting-refunds.component';
import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { AccountingComponent } from './accounting.component';
import { PaymentIndexComponent } from './payment';
import { ProfitLossIndexComponent } from './profit-loss';

const accountingRoutes: Routes = [
    {
        path: 'accounting',
        component: AccountingComponent,
        children: [
             {
                path: 'profit-loss',
                component: ProfitLossIndexComponent
            },
            {
                path: 'payment',
                component: PaymentIndexComponent
            },
            {
                path: 'refunds',
                component: AccountingRefundsComponent
            }
        ]
    }

];

export const accountingRouting: ModuleWithProviders = RouterModule.forChild(accountingRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/accounting.routing.ts